import type { ColumnDef } from '@tanstack/react-table';

import SkeletonLoading from '../../SkeletonLoading/SkeletonLoading';

interface LoadingRowData {
  [key: string]: string | number;
  uniqueTableRowIdentifier: string;
}

export const generateLoadingAttributes = <T,>(columns: ColumnDef<T, unknown>[], dataCount: number = 20, rowKey?: string) => {
  return {
    loadingColumns: generateLoadingColumns(columns),
    loadingData: generateLoadingData(dataCount, rowKey)
  };
};

const generateLoadingColumns = <T,>(columns: ColumnDef<T, unknown>[]): ColumnDef<T, unknown>[] => {
  return columns.map((column) => ({
    ...column,
    cell: () => <SkeletonLoading className="ml-0 mr-0" height={20} width="w-full" />
  }));
};

/**
 * Generates simple placeholder rows for loading state.
 * The actual skeleton UI is rendered by loadingColumns which override cell renderers.
 */
const generateLoadingData = (count: number, rowKey?: string): LoadingRowData[] => {
  return Array.from({ length: count }, (_, index) => {
    const rowData: LoadingRowData = { uniqueTableRowIdentifier: `loading-${index}` };

    if (rowKey) {
      rowData[rowKey] = index;
    }

    return rowData;
  });
};
